// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qjqs0rL5bkQQX1 {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.ScyTgXAPTHk6Xc {
  display: flex;
  justify-content: center;
}
.p25M7A0otHk0E3 {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.BzL2L5tRLhTQaJ {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.w5BRRt6kkvjFLU {
  font-style: italic;
}
.ZfESGNDINaNOmT {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.VuhbiIUdcXGZwn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ECLPBfmcNlvv0P {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.ECLPBfmcNlvv0P .kBf1p_s2GyQz7J {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.v3BMuNBbjbOy1O {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.v3BMuNBbjbOy1O button {
  margin-left: var(--ds-space-100, 8px);
}
.nLECO3RUjyF0Hc {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .ZfESGNDINaNOmT {
    padding: var(--ds-space-200, 16px);
  }
}
.IxHNn3dy3jJQEA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-100, 8px);
}
.IxHNn3dy3jJQEA label {
  font-weight: var(--ds-font-weight-bold, 700);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
}
.IxHNn3dy3jJQEA .JNmsIdgomwW6MA {
  display: block;
  width: 320px;
  min-width: 200px;
  margin-bottom: var(--ds-space-150, 12px);
}
.IxHNn3dy3jJQEA .JNmsIdgomwW6MA::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  margin-top: var(--ds-space-050, 4px);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA:hover,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA:focus,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA:disabled,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA[readonly],
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA.xz63E37dM03pDQ,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA.xz63E37dM03pDQ {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA.xz63E37dM03pDQ:hover,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA.xz63E37dM03pDQ:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA.xz63E37dM03pDQ:focus,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA.xz63E37dM03pDQ:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA.WZglm3fa9f5Zem,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA.WZglm3fa9f5Zem {
  width: 100%;
}
.IxHNn3dy3jJQEA input[type='text'].JNmsIdgomwW6MA::placeholder,
.IxHNn3dy3jJQEA input[type='email'].JNmsIdgomwW6MA::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.wHfub7SmQT4nFH {
  flex-grow: 1;
  margin-left: var(--ds-space-400, 32px);
}
@media only screen and (max-width: 900px) {
  .IxHNn3dy3jJQEA {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .wHfub7SmQT4nFH {
    margin-left: var(--ds-space-200, 16px);
    color: var(--ds-text-subtle, #44546f);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `qjqs0rL5bkQQX1`,
	"flexAndCenter": `ScyTgXAPTHk6Xc`,
	"body": `p25M7A0otHk0E3`,
	"navigationAndContent": `BzL2L5tRLhTQaJ`,
	"learnMoreSubtle": `w5BRRt6kkvjFLU`,
	"content": `ZfESGNDINaNOmT`,
	"spinnerContainer": `VuhbiIUdcXGZwn`,
	"header": `ECLPBfmcNlvv0P`,
	"title": `kBf1p_s2GyQz7J`,
	"footer": `v3BMuNBbjbOy1O`,
	"formFooter": `nLECO3RUjyF0Hc`,
	"formSection": `IxHNn3dy3jJQEA`,
	"pluginInput": `JNmsIdgomwW6MA`,
	"input-error": `xz63E37dM03pDQ`,
	"full": `WZglm3fa9f5Zem`,
	"inputDescription": `wHfub7SmQT4nFH`
};
export default ___CSS_LOADER_EXPORT___;
